module.exports = __webpack_public_path__ + "img/ammiraglio 4 bagno.181a7c9a.jpeg";